//  Some UIs (upload list, file upload) only available in split-view.
//  If user opens page on device with small screen, this component will
//  show an appropriate message.

import { SplitViewContext } from '../components/split_view';
import React                from 'react';


export default function SplitViewOnly({ children }) {
  return (
    <SplitViewContext.Consumer>{
      isSplitView => {
        if (isSplitView)
          return children;
        else {
          return (
            <div className="page-content">
              <div className="block inset">
                <h2>This feature is not supported on your device, please use a web browser</h2>
              </div>
            </div>
          );
        }
      }
    }
    </SplitViewContext.Consumer>
  );
}
